import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { isAdminFlow } from '../services/url-utils';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private authService: MsalService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const adminFlow = isAdminFlow();

    if (this.authService?.instance?.getActiveAccount() !== null) {
      if (adminFlow) {
        this.router.navigate(['candidate-search']);
      } else {
        this.router.navigate(['profile']);
      }
      return false;
    }
    return true;
  }
}
